export default __webpack_public_path__ + "locales/si/ConvertDialog.json?hash=a7af279f25b68dcb11ede227a9ce4006";